import * as React from 'react';

var _path, _path2;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.517 1.5c-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5 8.56 0 15.5-6.94 15.5-15.5 0-8.56-6.94-15.5-15.5-15.5zM.017 17C.017 7.887 7.404.5 16.517.5c9.112 0 16.5 7.387 16.5 16.5s-7.388 16.5-16.5 16.5C7.404 33.5.017 26.113.017 17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.038 24.02l5.42-5.42 1.06 1.061-7.23 7.232-7.232-7.232 1.06-1.06 5.422 5.421V7.965h1.5V24.02z"
  })));
}

export { SvgArrowDown as default };